import logo from '../assets/images/mimararchi.png';
import Platform from './Platform';
import { useProfileContext } from '../hooks/useProfileContext';
import BusinessLinks from './BusinessLinks';
import { useState } from 'react';
import RedProfile from './RedProfile';
import BlueProfile from './BlueProfile';

const MobileMocket = ({ profile }) => {
    const { profile: profileContext } = useProfileContext();
    const [showMore, setShowMore] = useState(false);
    let c;
    if (profile.colorTheme === '#d9d9d9') {
        c = '217, 217, 217'
        console.log(c)
    }
    else {
        c = profile.colorTheme
    }
    return (
        <div className="profileContainer">
            <div className="imgBundleContainer" style={{"background": profileContext.type === 'Blue' ? "linear-gradient(to top, white 0%, white 42%, #172c3d 42%, #172c3d 100% )": "white"}}>
                {
                    profileContext.type === "Blue" ? <BlueProfile job={profile.job} name={profileContext.name} image1={profile.image1} /> : <RedProfile job={profile.job} name={profileContext.name} image1={profile.image1} />
                }
            </div>
            <div className={profileContext.type === 'Blue' ? "dashcontactButtons":"contactButtons"}>
                <a style={{"fontFamily":profileContext.type ==="Blue"? "neufile-info":"sans-title",'pointerEvents': 'none'}} className={profileContext.type ==="Blue" ?'taskOpenBtnExBlue':"taskOpenBtnEx"} href={profile.contact_link}> SAVE CONTACT </a>
                <a style={{ "fontFamily":profileContext.type ==="Blue"? "neufile-info":"sans-title","textTransform":"unset", 'color': profileContext.type === "Blue"? 'white':"black" , "background": profileContext.type === "Blue"? "#172c3d":"#972721" ,'pointerEvents': 'none'  }} > EXCHANGE INFO </a>
            </div>
            <p style={{ "width": "90%", "marginBottom": "0px" }}>
                Contact Info
            </p>
            <div className="businessLinkHolder">
                {profile.socialMedia && profile.socialMedia.map((app, index) => (
                    <BusinessLinks corp={true} key={index} props={app} color={profile.colorTheme} idx={index} />
                ))}
            </div>
        </div>
    );
}
export default MobileMocket;